import React from 'react';
import icon from '../assets/icon.png';
import { Buttons } from '../components/Buttons';
import { FaCheckCircle } from 'react-icons/fa';

const stats = [
  { number: '20+', label: 'Years of Experience' },
  { number: '200+', label: 'Happy Clients' },
  { number: '10K+', label: 'Properties Managed' },
];

const whoWeServe = [
  'Individual property owners',
  'Real estate investors',
  'Commercial property owners',
  'Multi-property portfolio holders',
  'Homeowners associations (HOAs)',
];

const expertise = [
  'California real estate laws and regulations',
  'San Francisco rent control and ordinances',
  'Tenant screening and lease enforcement',
  'Property marketing and leasing strategies',
  'Financial reporting and investment optimization',
];

const approach = [
  'Minimize vacancies through effective marketing',
  'Maintain properties with preventative care',
  'Ensure full legal compliance',
  'Optimize rental income and ROI',
  'Build strong tenant relationships',
];

const whyTrust = [
  '20+ Years of Experience',
  'Licensed & Certified Professionals',
  'Strong Knowledge of California Laws',
  'Transparent Communication',
  'Proven Track Record of Results',
];

const services = [
  {
    title: 'Property Management',
    detail: 'Full-service oversight including tenant placement, rent collection, maintenance, and compliance.',
  },
  {
    title: 'Real Estate Services',
    detail: 'Buying, selling, and leasing support across residential and commercial properties.',
  },
  {
    title: 'Investment Support',
    detail: 'Market analysis, rental optimization, and long-term asset growth strategies.',
  },
];

const About = () => {
  return (
    <div className="w-full bg-black">

      {/* Hero Section */}
      <div className="w-full bg-[#1A1A1A] px-[4rem] py-[5rem] flex flex-col items-center gap-[1rem] text-center border-b border-[#262626]">
        <div className="flex gap-[5px] justify-center">
          <img src={icon} alt="" className="w-[24px] h-[24px] object-contain" />
          <p className="text-[18px] text-white">Experienced Property & Real Estate Professionals in the Bay Area</p>
        </div>
        <h1 className="text-[55px] leading-tight font-bold text-gradient">About Millennium Realty</h1>
        <p className="text-white text-[18px] font-light max-w-[800px]">
          Millennium Realty is a full-service real estate and property management firm serving San Francisco and the greater Bay Area, California. With over 20 years of industry experience, we specialize in managing residential and commercial properties while helping property owners maximize returns and minimize risk.
        </p>
        <p className="text-white text-[18px] font-light max-w-[800px]">
          Our company was built on a foundation of professionalism, transparency, and long-term client success.
        </p>
      </div>

      {/* Stats */}
      <div className="w-full px-[4rem] py-[3rem] flex justify-center gap-[2rem] flex-wrap bg-black border-b border-[#262626]">
        {stats.map((s, i) => (
          <div key={i} className="flex-1 min-w-[200px] bg-[#1A1A1A] border border-[#262626] rounded-lg px-[2rem] py-[2rem] flex flex-col gap-[0.3rem] items-start hover:bg-[#101010] transition-all duration-300">
            <h1 className="text-gradient text-[48px] font-bold">{s.number}</h1>
            <p className="text-white text-[18px]">{s.label}</p>
          </div>
        ))}
      </div>

      {/* Mission */}
      <div className="w-full px-[4rem] py-[5rem] bg-[#1A1A1A] border-b border-[#262626]">
        <div className="max-w-[900px] mx-auto text-center flex flex-col gap-[1rem]">
          <div className="flex gap-[5px] justify-center">
            <img src={icon} alt="" className="w-[24px] h-[24px] object-contain" />
            <p className="text-[18px] text-white">Driving Purpose</p>
          </div>
          <h2 className="text-[45px] font-bold text-gradient">Our Mission</h2>
          <p className="text-white text-[18px] font-light">Our mission is simple:</p>
          <p className="text-white text-[22px] font-normal italic border-l-4 border-[#EEC24B] pl-[1.5rem] text-left max-w-[700px] mx-auto">
            "To protect, manage, and grow our clients' real estate investments through strategic, compliant, and results-driven property management."
          </p>
        </div>
      </div>

      {/* Who We Serve & Expertise */}
      <div className="w-full px-[4rem] py-[5rem] bg-black border-b border-[#262626]">
        <div className="max-w-[1440px] mx-auto flex flex-wrap gap-[4rem] justify-between">
          <div className="flex-1 min-w-[280px] flex flex-col gap-[1.5rem]">
            <div className="flex gap-[5px]">
              <img src={icon} alt="" className="w-[24px] h-[24px] object-contain" />
              <p className="text-[18px] text-white">Clients</p>
            </div>
            <h2 className="text-[38px] font-bold text-gradient">Who We Serve</h2>
            <ul className="flex flex-col gap-[0.8rem]">
              {whoWeServe.map((item, i) => (
                <li key={i} className="flex items-start gap-[0.8rem]">
                  <FaCheckCircle className="text-[#EEC24B] mt-1 flex-shrink-0" size={18} />
                  <p className="text-white text-[18px] font-light">{item}</p>
                </li>
              ))}
            </ul>
          </div>

          <div className="flex-1 min-w-[280px] flex flex-col gap-[1.5rem]">
            <div className="flex gap-[5px]">
              <img src={icon} alt="" className="w-[24px] h-[24px] object-contain" />
              <p className="text-[18px] text-white">Knowledge</p>
            </div>
            <h2 className="text-[38px] font-bold text-gradient">Our Expertise</h2>
            <ul className="flex flex-col gap-[0.8rem]">
              {expertise.map((item, i) => (
                <li key={i} className="flex items-start gap-[0.8rem]">
                  <FaCheckCircle className="text-[#EEC24B] mt-1 flex-shrink-0" size={18} />
                  <p className="text-white text-[18px] font-light">{item}</p>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* What We Do */}
      <div className="w-full px-[4rem] py-[5rem] bg-[#1A1A1A] border-b border-[#262626]">
        <div className="max-w-[1440px] mx-auto flex flex-col gap-[3rem]">
          <div className="text-center flex flex-col gap-[1rem]">
            <div className="flex gap-[5px] justify-center">
              <img src={icon} alt="" className="w-[24px] h-[24px] object-contain" />
              <p className="text-[18px] text-white">Our Services</p>
            </div>
            <h2 className="text-[45px] font-bold text-gradient">What We Do</h2>
            <p className="text-white text-[18px] font-light max-w-[700px] mx-auto">
              We provide comprehensive services that cover every aspect of property management.
            </p>
          </div>
          <div className="flex flex-wrap gap-[2rem] justify-center">
            {services.map((s, i) => (
              <div key={i} className="flex-1 min-w-[280px] max-w-[380px] bg-[#111] border border-[#262626] rounded-lg p-[2rem] flex flex-col gap-[1rem] hover:border-[#EEC24B] transition-all duration-300">
                <h3 className="text-gradient text-[22px] font-bold">{s.title}</h3>
                <p className="text-white text-[17px] font-light">{s.detail}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Our Approach */}
      <div className="w-full px-[4rem] py-[5rem] bg-black border-b border-[#262626]">
        <div className="max-w-[1440px] mx-auto flex flex-wrap gap-[4rem] items-center justify-between">
          <div className="flex-1 min-w-[280px] flex flex-col gap-[1.5rem]">
            <div className="flex gap-[5px]">
              <img src={icon} alt="" className="w-[24px] h-[24px] object-contain" />
              <p className="text-[18px] text-white">How We Work</p>
            </div>
            <h2 className="text-[45px] font-bold text-gradient">Our Approach</h2>
            <p className="text-white text-[18px] font-light">
              At Millennium Realty, we take a proactive and strategic approach to property management.
            </p>
            <ul className="flex flex-col gap-[0.8rem]">
              {approach.map((item, i) => (
                <li key={i} className="flex items-start gap-[0.8rem]">
                  <FaCheckCircle className="text-[#EEC24B] mt-1 flex-shrink-0" size={18} />
                  <p className="text-white text-[18px] font-light">{item}</p>
                </li>
              ))}
            </ul>
          </div>

          <div className="flex-1 min-w-[280px] flex flex-col gap-[1.5rem]">
            <div className="flex gap-[5px]">
              <img src={icon} alt="" className="w-[24px] h-[24px] object-contain" />
              <p className="text-[18px] text-white">Trust</p>
            </div>
            <h2 className="text-[45px] font-bold text-gradient">Why Clients Trust Us</h2>
            <ul className="flex flex-col gap-[0.8rem]">
              {whyTrust.map((item, i) => (
                <li key={i} className="flex items-center gap-[0.8rem] bg-[#1A1A1A] border border-[#262626] rounded-lg px-[1.5rem] py-[1rem]">
                  <FaCheckCircle className="text-[#EEC24B] flex-shrink-0" size={20} />
                  <p className="text-white text-[18px] font-semibold">{item}</p>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* CTA */}
      <div className="w-full px-[4rem] py-[5rem] bg-[#1A1A1A] text-center flex flex-col gap-[1.5rem] items-center">
        <div className="flex gap-[5px] justify-center">
          <img src={icon} alt="" className="w-[24px] h-[24px] object-contain" />
          <p className="text-[18px] text-white">Building Long-Term Partnerships</p>
        </div>
        <h2 className="text-[45px] font-bold text-gradient">Work With Millennium Realty</h2>
        <p className="text-white text-[18px] font-light max-w-[800px]">
          Whether you own a single property or a large portfolio, Millennium Realty is here to deliver professional, reliable, and results-driven service across the Bay Area. Contact us today to learn more about how we can support your real estate goals.
        </p>
        <Buttons title="Contact Us Today" width="220px" to="/contact" />
      </div>

    </div>
  );
};

export default About;
